import { useLayoutEffect } from 'preact/hooks';
import {
  useSceneLoaderContext,
  useCheckoutStore,
  useCheckoutContext,
} from '@primer-io/shared-library/contexts';
import { Scene } from '../../enums/Checkout';
import { Icons } from '../../assets/icons/Icons';
import { useSceneMounting } from '../../utils/hooks';
import { CheckoutOptions, CheckSuccessScreenOptions } from '../../types';
import getLabel from '../../utils/getLabel';

const SCENE = Scene.SUCCESS_CHECK;

const CheckSuccessScene = () => {
  const store = useCheckoutStore();
  const { options } = useCheckoutContext();
  const { setIsMounted } = useSceneLoaderContext();

  useLayoutEffect(() => {
    setIsMounted();
  }, []);

  useSceneMounting(() => {
    store.setSubmitButtonVisible(false);
  }, SCENE);

  const { title: successScreenTitle } =
    ((options as CheckoutOptions).successScreen as CheckSuccessScreenOptions) ??
    {};

  let successTitleLabel: string | undefined;
  if (successScreenTitle) {
    successTitleLabel = getLabel(successScreenTitle, {
      locale: store.getState().locale,
    });
  } else {
    successTitleLabel = store.getTranslations().checkSuccessTitle;
  }

  return (
    <div
      id={SCENE}
      class='PrimerCheckout__scene PrimerCheckout--exited PrimerCheckout__check'
    >
      <img
        src={Icons.successCheck}
        alt='success check mark'
        class='PrimerCheckout__checkMarkIcon'
      />
      <div class='PrimerCheckout__label'>{successTitleLabel}</div>
    </div>
  );
};

export default CheckSuccessScene;
